import { Component, OnInit, Inject, ViewEncapsulation, Optional, SimpleChanges } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { ServiceDeliveryBacklogInfo } from '../model/ServiceDeliveryBacklogInfo.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { TeamInfo } from '../model/team.model';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { StateInfo } from '../model/StateInfo.model';
import { DatePipe, Location } from '@angular/common';
import { LeadTansactionInfo } from '../model/leadtansaction.model';

@Component({
  selector: 'app-service-delivery-backlog-all',
  templateUrl: './service-delivery-backlog-all.component.html',
  styleUrls: ['./service-delivery-backlog-all.component.css']
})
export class ServiceDeliveryBacklogAllComponent implements OnInit {
  baseurl: string;
  expense_baseurl: string;
  form: FormGroup;

  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;
  _ParamTeamCode: string;
  _ParamTeamName: string;

  ProjectSaleCodeSearch: string;
  ProjectSaleNameSearch: string;
  txtSearchSaleTeam: string | null = null;
  txtSearchSaleTeamMember: string | null = null
  MyEmployeeNameWithUnder: string = '';
  txtSearchBacklogStatus: string | null = null;

  //SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamList: TeamInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];
  BacklogStatusList: LookupInfo[] = [];

  ServiceDeliveryBacklogListPromise: Promise<ServiceDeliveryBacklogInfo[]>;
  ServiceDeliveryBacklogList: ServiceDeliveryBacklogInfo[] = []
  ServiceDeliveryBacklogListPromisereturn: Promise<ServiceDeliveryBacklogInfo[]>[]

  // Zone pagination variable //
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number = 10;
  totalItems: number = 0;

  isSearchSubmitted: boolean = false;

  constructor(
    private httpClient: HttpClient, 
    @Inject('BASE_URL') baseUrl: string, 
    private formBuilder: FormBuilder, 
    private GlobalService: GlobalService, 
    private activatedRoute: ActivatedRoute, 
    private TokenService: TokenService, 
    private router: Router, 
    private location: Location
  ) { 
    this.baseurl = environment.base_api;
    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this.expense_baseurl = environment.expense_base_api;
    GlobalService.CheckPagingAccessRights();
  }

  async ngOnInit(): Promise<void> {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }
    
    await this.LoadBacklogStatusList();
    this.LoadSaleTeam();

    this.currentPageNumber = 1;
    this.LoadServiceDeliveryBacklog();
  }

  async LoadSaleTeam() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);

      let strjson = JSON.stringify(objectjson);

      //this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
      this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/GetTeamCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data

          // if(this.SaleTeamList.length > 0) {
          //   this.MyEmployeeNameWithUnder = this.SaleTeamList[0].EmployeeName;
          // }
        });
    }
  }

  async LoadSaleTeamUnders() {

    this.SaleTeamUnderList = [];
    this.txtSearchSaleTeamMember = null;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
      //objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      //objectjson['AssignedSellerOnly'] = true;
      //objectjson['MyEmployeeCodeWithUnder'] = this.checkUndefinedString(this._EmpCode);
      //objectjson['MyEmployeeNameWithUnder'] = this.checkUndefinedString(this.MyEmployeeNameWithUnder);
      let strjson = JSON.stringify(objectjson);

      //this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeamRequest", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamUnderList = data
        });
    }
  }

  public btnSearchServiceDeliveryBacklog_OnClick() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;

    this.isSearchSubmitted = true;
    this.LoadServiceDeliveryBacklog();
  }

  public btnclearServiceDeliveryBacklog_OnClick() {
    this.ProjectSaleCodeSearch = null;
    this.ProjectSaleNameSearch = null;
    this.txtSearchSaleTeam = null;
    this.txtSearchSaleTeamMember = null;
    this.txtSearchBacklogStatus = null;
  }

  async LoadServiceDeliveryBacklog(traget = null) {
    if (traget != null) {
      //this.LoadServiceDeliveryBacklogUpdatePagination(traget);
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    var auth_token = await this.TokenService.RefreshToken();

    if (!!auth_token) {
      await this.LoadServiceDeliveryBacklogList(auth_token);
    }
  }

  async LoadServiceDeliveryBacklogList(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * this.environment;

    var objectjson = {};
    objectjson['ServiceDeliveryBacklogProjectSaleCode'] = this.checkUndefinedString(this.ProjectSaleCodeSearch);
    objectjson['ServiceDeliveryBacklogProjectSaleName'] = this.checkUndefinedString(this.ProjectSaleNameSearch);
    objectjson['ServiceDeliveryBacklogSaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
    objectjson['ServiceDeliveryBacklogStatus'] = this.checkUndefinedString(this.txtSearchBacklogStatus);
    //objectjson['ProjectSaleAssignTo'] = this.checkUndefinedString(this.txtSearchSaleTeamMember);

    //console.log('txtSearchSaleTeamMember!!', this.txtSearchSaleTeamMember);
    if (this.txtSearchSaleTeamMember != null){
      //console.log('txtSearchSaleTeamMember !==null', this.txtSearchSaleTeamMember);
      objectjson['ProjectSaleAssignTo'] = this.txtSearchSaleTeamMember;
    } 
    //else {
      //console.log('txtSearchSaleTeamMember ==null', this.txtSearchSaleTeamMember);
    //  objectjson['AllUnderEmpCode'] = this._EmpCode; //
    //}

    objectjson['ServiceDeliveryBacklogSaleTeamMappingEmpCode'] = this._EmpCode;
    objectjson['SaleOrderBacklogMappingEmpCode'] = this._EmpCode;
    objectjson['rowFetch'] = this.environment;
    objectjson['rowOFFSet'] = offset;

    let strjson = JSON.stringify(objectjson);

    const response = await this.httpClient.post<any>(
        this.baseurl + "ServiceDeliveryBacklog/GetServiceDeliveryBacklogAll",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ServiceDeliveryBacklogList = response;
      this.totalItems = this.ServiceDeliveryBacklogList.length;

      if (this.ServiceDeliveryBacklogList.length <= 0) {
        this.currentPageNumber = 0;
      } else {
        if (this.currentPageNumber == 0) this.currentPageNumber = 1;
        this.totalItems = Number(this.ServiceDeliveryBacklogList[0].itemTotal);
      }

      // Calculate total pages
      this.totalPages = Math.ceil(this.totalItems / this.environment);
  }

  LoadServiceDeliveryBacklogUpdatePagination(traget) {

    if (traget > 0) {
      this.currentPageNumber = traget;
    }
    this.LoadServiceDeliveryBacklog();
  }

  async LoadBacklogStatusList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        LookupType: "ServiceDeliveryBacklogStatus"
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.BacklogStatusList = response;

    } catch (error) {
      console.error('Error loading company group:', error);
      alert('An error occurred while loading company group data. Please try again.');
    } finally {
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

}
